import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_SOLUTIONS_BY_SLUG = gql`
  query GetSolutionsBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on SolutionProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            exclusiveBrand
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              contactLensCareType
              volume
              volumeUnit
              solutionType

              targetUsers
              convenience
              keyInstructions

              lensTypeTarget
              caseIncluded
              minimumCycleTime
              preservativeFree
              maxTimeFrameInLensCase
              expirationAfterOpening

              hasDisinfect
              forHydration
              additionalComfort
              superiorCleaning
              forSensitiveEyes
              rinsable
              subscriptionIntervals
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;

export { GET_SOLUTIONS_BY_SLUG };
//# sourceMappingURL=get-solutions-by-slug.js.map
